import { render, staticRenderFns } from "./ServiceParameters.vue?vue&type=template&id=582dba81&scoped=true&"
import script from "./ServiceParameters.vue?vue&type=script&lang=ts&"
export * from "./ServiceParameters.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceParameters.vue?vue&type=style&index=0&id=582dba81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582dba81",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCheckbox,VTextField})
